import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { NgModule, Injectable } from '@angular/core';
import { NavMenuComponent } from './navmenu/navmenu.component';
import { APP_BASE_HREF, CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';
import { EmbedVideo } from 'ngx-embed-video';
import { HttpClientModule } from '@angular/common/http';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { CoursewareComponent } from './courseware/courseware.component';
import { CoursewareService } from '../services/CoursewareService';
import { CoursewareTopicComponent } from './courseware/courseware-topic.component';
import { CoursewareTopicEntriesComponent } from './courseware/courseware-topic-entries.component';
import { ShortVideosComponent } from './short-videos/short-videos.component';
import { DisplayTopicComponent } from './display-topic/display-topic.component';
import { DisplayContentEntryComponent } from './display-topic/display-content-entry.component';
import { DisplayContentVideoComponent } from './display-topic/display-content-video.component';
import { BlogsComponent } from './blogs/blogs.component';
import { VideocoursesComponent } from './videocourses/videocourses.component';
import { VideocoursecontentComponent } from './videocourses/videocoursecontent.component';
import { VideocoursemoduleComponent } from './videocourses/videocoursemodule.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BreadcrumbsComponent } from './shared/breadcrumbs.component';
import { ResearchIndexComponent } from './researchindex/research-index.component';
import { ResearchIndexEntryComponent } from './researchindex/research-index-entry.component';
import { LoginComponent } from './account/login.component';
import { RegisterComponent } from './account/register.component';
import { AlertModule } from './_alert';
import { TermsOfServiceComponent } from './home/terms-of-service.component';
import { CompleteRegistrationComponent } from './account/complete-registration.component';
import { DisplayShortVideosContentEntryComponent } from './short-videos/display-short-videos-content-entry.component';
import { DisplayBlogContentEntryComponent } from './blogs/display-blog-content-entry.component';
import { ContactUsComponent } from './home/contact-us.component';
import { SiteMapComponent } from './home/site-map.component';
import { TermsOfServicePageComponent } from './home/terms-of-service-page.component';
import { QuizQuestion } from './quiz/quiz-question.component';
import { QuizAnswer } from './quiz/quiz-answer.component';
import { AboutUsComponent } from './home/about-us.component';
import { ExamComponent } from './exam/exam.component';
import { HeaderAdComponent } from './shared/header-ad.component';
import { SiteMapEntryComponent } from './home/site-map-entry.component';
import { AccountComponent } from './account/account.component';
import { ForgotPasswordComponent } from './account/forgot-password.component';
import { ResetPasswordComponent } from './account/reset-password.component';
import { ExplainerComponent } from './videocourses/explainer.component';
import { SafeHtmlPipe } from './shared/safe-html-pipe.component';
import { SeeAlsoComponent } from './videocourses/see-also.component';
//import { JwSocialButtonsModule } from 'jw-angular-social-buttons';
import { SocialMediaComponent } from './shared/social-media.component';
import { MetaService } from 'src/services/MetaService';
import { BackOfficeComponent } from './shared/backoffice.component';
//import { ServiceWorkerModule } from '@angular/service-worker';
//import { CacheLocalStorageModule, CacheModule, MemoryCacheModule } from '@dagonmetric/ng-cache';
//import { Location } from '@angular/common';

import { BrowserTransferStateModule } from '@angular/platform-browser';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { CoursewareQuizComponent } from './courseware/courseware-quiz.component';
import { VideocoursemoduleTestComponent } from './videocourses/videocoursemoduletest.component';
import { PreviousRouteService } from 'src/services/PreviousRouteService';


const routes: Routes = [
  { path: 'homeview', component: HomeComponent },
  { path: 'home/index', component: HomeComponent },
  { path: 'explainerview', component: ExplainerComponent },
  { path: 'forgotpasswordview', component: ForgotPasswordComponent },
  { path: 'resetpasswordview', component: ResetPasswordComponent },
  // { path: 'resetpasswordview/:tokenID', component: ResetPasswordComponent },
  { path: 'accountview', component: AccountComponent },
  { path: 'examview/:id/:breadcrumbs', component: ExamComponent },
  { path: 'courseware', component: CoursewareComponent },
  { path: 'courseware/topic/:levelonealias', component: CoursewareComponent },
  { path: 'coursewareview', component: CoursewareComponent },
  { path: 'coursewareview/:levelonealias', component: CoursewareComponent },
  { path: 'coursewareview/:levelonealias/:leveltwoalias', component: CoursewareComponent },
  { path: 'courseware/entry/:alias', component: CoursewareTopicEntriesComponent },
  { path: 'coursewarecontentview/:alias', component: CoursewareTopicEntriesComponent },
  { path: 'coursewarequizview/:alias', component: CoursewareQuizComponent },
  { path: 'videos', component: ShortVideosComponent },
  { path: 'shortvideosview', component: ShortVideosComponent },
  { path: 'videos/topic/:alias', component: ShortVideosComponent },
  { path: 'shortvideosview/:alias', component: ShortVideosComponent },
  { path: 'videos/entry/:alias', component: DisplayShortVideosContentEntryComponent },
  { path: 'shortvideoscontentview/:alias', component: DisplayShortVideosContentEntryComponent },
  { path: 'blog', component: BlogsComponent },
  { path: 'blogview', component: BlogsComponent },
  { path: 'blogentryview/:alias', component: DisplayBlogContentEntryComponent },
  { path: 'blog/post/:alias', component: DisplayBlogContentEntryComponent },
  { path: 'loginview', component: LoginComponent },
  { path: 'account/register', component: RegisterComponent },
  { path: 'registerview', component: RegisterComponent },
  { path: 'videocourses', component: VideocoursesComponent },
  { path: 'videocoursesview', component: VideocoursesComponent },
  { path: 'completeregistrationview', component: CompleteRegistrationComponent },
  { path: 'completeregistrationview/:memberID', component: CompleteRegistrationComponent },
  { path: 'videocourses/topic/:alias', component: VideocoursesComponent },
  { path: 'videocoursesview/:alias', component: VideocoursesComponent },
  { path: 'videocoursesbannerview/:frombanner', component: VideocoursesComponent },
  //  { path: 'videocoursesmoduleexamview/:alias', component: VideocoursemoduleTestComponent },
  { path: 'videocoursescontentview/:alias', component: VideocoursecontentComponent },
  { path: 'videocourses/videocourse/:alias', component: VideocoursecontentComponent },
  { path: 'digitalbadges/digitalbadge/:alias', component: VideocoursecontentComponent },
  { path: 'videocoursesmoduleview/:alias', component: VideocoursemoduleComponent },
  { path: 'videocourses/entry/:alias', component: VideocoursemoduleComponent },
  { path: 'digitalbadges/entry/:alias', component: VideocoursemoduleComponent },

  { path: 'researchindexview/:indexentry', component: ResearchIndexComponent },
  { path: 'researchindexview', component: ResearchIndexComponent },
  { path: 'concept', component: ResearchIndexComponent },
  { path: 'concept?startingLetter=:startingLetter', component: ResearchIndexComponent },

  { path: 'contactusview', component: ContactUsComponent },
  { path: 'home/contact', component: ContactUsComponent },
  { path: 'termsofserviceview', component: TermsOfServicePageComponent },
  { path: 'home/termsofservice', component: TermsOfServicePageComponent },
  { path: 'sitemapview', component: SiteMapComponent },
  { path: 'home/toc', component: SiteMapComponent },
  { path: 'aboutusview', component: AboutUsComponent },
  { path: 'home/about', component: AboutUsComponent },
  { path: 'backoffice', component: BackOfficeComponent },
  { path: '**', redirectTo: 'homeview' }
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    NavMenuComponent,
    CoursewareComponent,
    CoursewareTopicComponent,
    CoursewareTopicEntriesComponent,
    CoursewareQuizComponent,
    ShortVideosComponent,
    DisplayTopicComponent,
    DisplayContentEntryComponent,
    DisplayContentVideoComponent,
    BlogsComponent,
    VideocoursesComponent,
    VideocoursecontentComponent,
    VideocoursemoduleComponent,
    VideocoursemoduleTestComponent,
    BreadcrumbsComponent,
    ResearchIndexComponent,
    ResearchIndexEntryComponent,
    LoginComponent,
    RegisterComponent,
    TermsOfServiceComponent,
    CompleteRegistrationComponent,
    DisplayShortVideosContentEntryComponent,
    DisplayBlogContentEntryComponent,
    ContactUsComponent,
    SiteMapComponent,
    TermsOfServicePageComponent,
    QuizQuestion,
    QuizAnswer,
    AboutUsComponent,
    ExamComponent,
    HeaderAdComponent,
    SiteMapEntryComponent,
    AccountComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    ExplainerComponent,
    SafeHtmlPipe,
    SeeAlsoComponent,
    SocialMediaComponent,
    BackOfficeComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    CommonModule,
    FormsModule,
    HttpClientModule,
    AlertModule,
    NgbModule,
    BrowserTransferStateModule,
    TransferHttpCacheModule,
    CarouselModule.forRoot(),
    EmbedVideo.forRoot(),
    //    JwSocialButtonsModule,
    //    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    //    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', scrollPositionRestoration: "enabled", initialNavigation: 'enabled' })
    //    RouterModule.forRoot(routes, {   enableTracing: true, onSameUrlNavigation: 'reload', scrollPositionRestoration: "enabled", initialNavigation: 'enabled' })
  ],
  exports: [RouterModule],
  //  providers: [ { provide: APP_BASE_HREF, useValue: '/' }, CoursewareService, MetaService, { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true}]
  providers: [{ provide: APP_BASE_HREF, useValue: '/' }, CoursewareService, MetaService, PreviousRouteService],
  //providers: [ { provide: 'googleTagManagerId', useValue: 'UA-103104789-1' }, { provide: APP_BASE_HREF, useValue: '/' }, CoursewareService, MetaService],
  bootstrap: [AppComponent]
})

export class AppModule { }

